// the arguments of the Model call the item mediator is making: a Model made of Matreshka.Array takes the item's
// data as its items, not (data, parentArray, index)
var modelCall = {
  args: null
};
export default modelCall;